import { PublicClient } from 'viem';
import { ERC20ABI } from '@/config';

interface TokenInfo {
  name_: string;
  symbol_: string;
  decimals_: number;
}

const getTokenInfo = async (
  address: string,
  publicClient: PublicClient
): Promise<TokenInfo> => {
  const addr = address as `0x${string}`;

  try {
    const results = await publicClient.multicall({
      contracts: [
        {
          address: addr,
          abi: ERC20ABI,
          functionName: 'name',
        },
        {
          address: addr,
          abi: ERC20ABI,
          functionName: 'symbol',
        },
        {
          address: addr,
          abi: ERC20ABI,
          functionName: 'decimals',
        },
      ],
      allowFailure: true,
      authorizationList: undefined
    });


    const [nameResult, symbolResult, decimalsResult] = results;

    return {
      name_:
        nameResult.status === 'success'
          ? String(nameResult.result)
          : '',

      symbol_:
        symbolResult.status === 'success'
          ? String(symbolResult.result)
          : '',

      decimals_:
        decimalsResult.status === 'success'
          ? Number(decimalsResult.result)
          : 18,
    };
  } catch (error) {
    console.error('getTokenInfo error:', error);
    throw error;
  }
};

export default getTokenInfo;